module.exports = __webpack_public_path__ + "media/images/media/images/pic/teachers/magdalena-kisly-e50a0f91edc070dca0b0066a134ce614.png";